import { DeepPartial, NextQueriesConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_NEXT_QUERIES: DeepPartial<NextQueriesConfig> = { results: 6 };
export const DESKTOP_NEXT_QUERIES: DeepPartial<NextQueriesConfig> = { gridColumns: 6 };
